import { QueryCache, QueryClient } from "@tanstack/react-query"

import { errorToast } from "./error-toast"

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
        },
    },
    queryCache: new QueryCache({
        onError: (error, query) => {
            if (query.meta?.errorToast && query.state.data === undefined) {
                errorToast(error)
            }
        },
    }),
})

export default queryClient
